import { getItem, setItem } from '../utils/localStorage';
import { IListSelector } from '../app/@types/subHeaderSelector';

interface IHotelSelectionData {
  selectedHotel: IListSelector | undefined;
  hotelName: string;
  brandName: string;
  hotelsWithSelection: IListSelector[];
}

interface IHotelSelectionUpdate {
  updatedHotelList: IListSelector[];
  selectedHotel: IListSelector | undefined;
}

/**
 * Gets the initial hotel selection data from localStorage and maps hotels with selection state
 */
export function getInitialHotelSelectionData (allHotels: IListSelector[]): IHotelSelectionData {
  const selectedHotelId = getItem('selectedHotel');
  const selectedClientId = getItem('selectedClient');
  const selectedBrandId = getItem('selectedBrand');

  const selectedHotel = allHotels.find(
    (hotel) =>
      hotel.id === selectedHotelId &&
      hotel.clientId === selectedClientId &&
      hotel.brandId === selectedBrandId
  );

  const hotelName = (selectedHotel && selectedHotel.name) || '';
  const brandName = (selectedHotel && selectedHotel.brandName) || '';

  const hotelsWithSelection = allHotels.map((hotel) => ({
    ...hotel,
    selected:
      hotel.id === selectedHotelId &&
      hotel.clientId === selectedClientId &&
      hotel.brandId === selectedBrandId,
  }));

  return {
    selectedHotel,
    hotelName,
    brandName,
    hotelsWithSelection,
  };
}

/**
 * Updates the hotel selection in the list and persists to localStorage
 */
export function updateHotelSelection (
  hotelList: IListSelector[],
  hotelId: string | number,
  clientId: string | number,
  brandId: string | number
): IHotelSelectionUpdate {
  let selectedHotel: IListSelector | undefined;

  const updatedHotelList = hotelList.map((hotel) => {
    const isSelected =
      hotel.id === hotelId &&
      hotel.clientId === clientId &&
      hotel.brandId === brandId;

    if (isSelected) {
      selectedHotel = hotel;
      setItem('selectedHotel', hotel.id);
      setItem('selectedBrand', hotel.brandId);
      setItem('selectedClient', hotel.clientId);
    }

    return {
      ...hotel,
      selected: isSelected,
    };
  });

  return {
    updatedHotelList,
    selectedHotel,
  };
}
